module.exports = __webpack_public_path__ + "static/media/socialYoutube.a1b40111.svg";